

function joinClasses(...args) {
    return args.filter(Boolean).join(' ');
  }
  
  export default joinClasses;
  